import { Col, Form, message, Row, Upload, Typography } from "antd";
import { useTranslation } from "react-i18next";

import stylesOnb from '../../../../styles/screens/Onboarding.module.scss';
import ImagePreviewSection from "./components/ImageSection";

const { Text } = Typography;

const UploadLogo = ({
    setCurrentSrc,
    currentSrc
}: any) => {

    const { t: cw } = useTranslation('onboarding', { keyPrefix: 'CREATE_WORKSPACE' });

    const normFile = (e: any) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };

    const draggerProps = {
        name: 'file',
        multiple: false,
        accept: 'image/png,image/jpeg',
        beforeUpload: (file: File) => {
          const isAccepted = file.type === 'image/png' || file.type === 'image/jpeg';
          if (!isAccepted) {
            message.error(cw('FILE_UPLOADED_NOT_ACCEPTED'));
            return Upload.LIST_IGNORE;
          }
          setCurrentSrc(URL.createObjectURL(file));
          return false;
        },
        onRemove: () => {
          setCurrentSrc(null);
        }
      };

    return (
        <Row justify="space-between" align="middle">
            <Col lg={11} md={24}>
                <Form.Item
                    name="logo"
                    valuePropName="fileList"
                    getValueFromEvent={normFile}
                    noStyle
                    className={stylesOnb.dragger}
                >
                    <Upload.Dragger
                        style={{ padding: "16px" }}
                        itemRender={() => <></>}
                        maxCount={1} {...draggerProps}
                    >
                        <Text>
                            {cw('HELP_LOGO')}
                        </Text>
                    </Upload.Dragger>
                </Form.Item>
            </Col>
            <Col lg={11} md={24} span={11}>
                <ImagePreviewSection src={currentSrc} />
            </Col>
        </Row>
    )
}

export default UploadLogo;